import { render, staticRenderFns } from "./researchdevelopment.vue?vue&type=template&id=56392ec6&scoped=true&"
import script from "./researchdevelopment.vue?vue&type=script&lang=js&"
export * from "./researchdevelopment.vue?vue&type=script&lang=js&"
import style0 from "./researchdevelopment.vue?vue&type=style&index=0&id=56392ec6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56392ec6",
  null
  
)

export default component.exports